<template>
    <b-modal
        ref="show-modal"
        :title="$t('waiting_room.show_modal.title')"
        cancel-title="Close"
        ok-only
        size="lg"
    >
      <h4>{{ $t('waiting_room.show_modal.section_basic_data_title') }}</h4>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $t('waiting_room.show_modal.id') }}</th>
              <td>{{ data.id }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.name') }}</th>
              <td>{{ data.name }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.question_category') }}</th>
              <td>{{ $t(`category.${data.questionCategoryLabel}`) }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.wallet_currency') }}</th>
              <td>{{ data.walletCurrency }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.buy_in') }}</th>
              <td>{{ data.buyIn }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.prize_pool') }}</th>
              <td>{{ data.prizePool }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.max_players') }}</th>
              <td>{{ data.gameParameters.maxPlayers }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.quiz_ranking_points') }}</th>
              <td>
                <ul style="list-style: none; padding-left: 0;">
                  <li v-for="(item, key, index) in data.quizRankingPoints" :key="index">{{ item.position }}: {{ item.points }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.password') }}</th>
              <td>{{ data.password }}</td>
            </tr>
            <tr>
              <th>{{ $t('waiting_room.show_modal.created_at') }}</th>
              <td>{{ data.createdAt | dateTime24HoursUTCFormat }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h4>{{ $t('waiting_room.show_modal.section_stages_title') }}</h4>
          <table class="table">
            <tr>
              <th>{{ $t('waiting_room.show_modal.round_type') }}</th>
              <th>{{ $t('waiting_room.show_modal.cms_key_name') }}</th>
              <th>{{ $t('waiting_room.show_modal.number_of_rounds') }}</th>
              <th>{{ $t('waiting_room.show_modal.round_configuration') }}</th>
            </tr>
            <tr v-for="(stage, index) in data.gameParameters.stagesParameters" :key="index">
              <td>{{ stage.roundType }}</td>
              <td>{{ stage.cmsKeyName }}</td>
              <td>{{ stage.numberOfRounds }}</td>
              <td>
                <ul>
                  <li v-for="(value,key) in stage.roundConfiguration" :key="key">{{ key }}:{{ value }}</li>
                </ul>
              </td>
            </tr>
          </table>
          <h4>{{ $t('waiting_room.show_modal.section_final_stages_title') }}</h4>
          <table class="table">
            <tr>
              <th>{{ $t('waiting_room.show_modal.min_time') }}</th>
              <th>{{ $t('waiting_room.show_modal.points_multiplier') }}</th>
              <th>{{ $t('waiting_room.show_modal.cms_key_name') }}</th>
              <th>{{ $t('waiting_room.show_modal.rounds_no_to_change_time') }}</th>
              <th>{{ $t('waiting_room.show_modal.time_bonus') }}</th>
              <th>{{ $t('waiting_room.show_modal.time_penalty') }}</th>
            </tr>
            <tr>
              <td>{{data.gameParameters.finalStageParameters.minAmountOfTime}}s</td>
              <td>{{data.gameParameters.finalStageParameters.pointsMultiplier}}</td>
              <td>{{data.gameParameters.finalStageParameters.cmsPageKeyName}}</td>
              <td>{{data.gameParameters.finalStageParameters.numberOfRoundsToChangeTime}}</td>
              <td>{{data.gameParameters.finalStageParameters.roundConfiguration.questionTimeBonus}}s</td>
              <td>{{data.gameParameters.finalStageParameters.roundConfiguration.questionTimePenalty}}s</td>
            </tr>
          </table>
        </div>
      </div>
    </b-modal>
</template>


<script>

//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  data() {
    return {
      data: {
        id: null,
        name: null,
        createdAt: null,
        questionCategoryLabel: null,
        walletCurrency: null,
        buyIn: null,
        prizePool: null,
        gameParameters: {
          buyIn: null,
          quizRankingPoints: null,
          prizePool: null,
          maxPlayers: null,
          walletCurrency: null,
          stagesParameters: [],
          finalStageParameters: {
            pointsMultiplier: null,
            minAmountOfTime: null,
            numberOfRoundsToChangeTime: null,
            roundConfiguration: {
              questionTimeBonus: null,
              questionTimePenalty: null,
            },
            cmsPageKeyName: null
          },
        },

      }
    };
  },
  filters: {},
  mounted() {
    this.showModal();
  },
  methods: {
    setData(data) {
      this.data = data;
    },
    showModal(){
      this.$refs['show-modal'].show();
    }
  }
}
</script>
